import React from 'react';
import darkOrLightMode from '../../../../../utils/helpers/colorMode';
import QISignTheme from '../../../../../interfaces/Theme';
import { resolveColor } from '../../../theme/utils/resolveColor';
import * as S from './styles';

interface ButtonProps {
    clientThemeSettings: QISignTheme;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    children: React.ReactNode;
    variant?: 'filled' | 'soft';
}

export const Button = ({
    clientThemeSettings,
    onClick,
    disabled = false,
    loading = false,
    variant = 'filled',
    children,
}: ButtonProps) => {
    const backgroundColor = resolveColor('primary', clientThemeSettings);
    const textColor =
        darkOrLightMode(backgroundColor) === 'light mode' ? '#232323' : '#ffffff';

    return (
        <S.StyledButton
            $backgroundColor={backgroundColor}
            $textColor={textColor}
            $variant={variant}
            $disabled={disabled}
            $loading={loading}
            onClick={() => !disabled && !loading && onClick()}
        >
            {children}
        </S.StyledButton>
    );
};
